export default {
	login: {
		keepSignedIn: 'angemeldet bleiben',
		forgotPassword: 'Passwort vergessen',
		selectManagement: 'Verwaltung auswählen',
		select: 'Auswählen',
		reset: {
			title: 'Password Ändern',
			changePasswordText:
				'Bitte geben Sie Ihr gewünschtes Passwort in ' +
				'das nachstehende Feld ein und bestätigen Sie dies in dem zweiten Feld. ' +
				'Die Passwortstärke zeigt Ihnen an, wie sicher Ihr gewähltes Passwort ist.',
			usernameEmail: '@:common.usernameEmail',
			currentPassword: 'Bisheriges Passwort',
			newPassword: 'Neues Passwort',
			confirmNewPassword: 'Bestätigung des neuen Passworts',
		},
		lost: {
			title: 'Passwort vergessen',
			lostPasswordText: `Bitte geben Sie Ihre E-Mail Adresse an, damit wir Ihnen einen Link zur
			Wiederherstellung Ihres Passworts zusenden können. Alle weiteren
			erforderlichen Maßnahmen ergeben sich aus der E-Mail die Ihnen
			zugesendet wird.`,
			usernameEmail: '@:common.emailAdress',
			tooManyAttemptsError: 'Zu viele Versuche. Bitte versuchen Sie es in ein paar Minuten erneut.',
			lostPasswordSuccess : 'Eine E-Mail wurde an Ihre Adresse gesendet'
		}
	},
}
